import {MapTo} from '../../../infrastructure/compatibility/MapTo';
import {Main} from './Main';

export const IdhubProductExperienceMain = MapTo(
    'vwa-ngw18/components/structure/idhubproductexperiencemain',
    Main
);
